export const MAP_PERSPECTIVES = {
  ATTACKER: 'ATTACKER',
  DEFENDER: 'DEFENDER'
};